<template>
  <div style="padding: 80px 20px;">
    <!-- <div style="text-align: center;">
      <h2 style="font-weight: 500; margin: 5px auto;">請選擇服務</h2>
    </div><hr style="width: 100%"/> -->
    <el-row style="padding: 20px;" :gutter="20">
      <el-col :xs="12" :sm="8" :md="6" :lg="6" :xl="4" v-for="(service, index) in Services" :key="index" style="margin-bottom: 20px;">
        <div class="box1" @click="redirect(service.router)">
          <!-- <div class="box2" v-if="service.title === '聊天機器人'"></div> -->
          <h3 style="font-weight: 500; margin-top: 7px;"><mu-icon :value="service.icon" class="icon" :color="service.color"></mu-icon> {{ service.title }}</h3>
          <p style="opacity: 0.7;">{{ service.describe }}</p>
          <!-- <div style="position: absolute; right: 20px; bottom: 10px;">
            <span v-if="service.title === '聊天機器人'" style="color: #999;">即將開放</span>
          </div> -->
        </div>
      </el-col>
    </el-row>
    <div style="position: fixed; bottom: 10px; left: 20px; text-align: left;">
      <img src="https://i.imgur.com/SITKieL.png" width="120"/>
      <div style="padding-left: 12px; font-size: 13px;">Copyright © 2020 埃立思科技股份有限公司 版權所有</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      Services: [
        {
          color: '#00c300',
          icon: 'chat',
          title: '聊天機器人',
          describe: '為你的 LINE@ 打造客製化的智慧互動助理',
          router: 'chatbot'
        },
        {
          color: '#f24',
          icon: 'people',
          title: 'EILIS 社群數位會員卡',
          describe: '透過數位會員卡系統，協助串接系統資料庫，達到多管道資訊整合',
          router: 'shoplist'
        }
      ],
    };
  },
  methods: {
    redirect(val) {
      if (val) {
        this.$router.push(val);
      }
    },
  },
}
</script>

<style scoped>
  .box1 {
    text-align: left;
    box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
    padding: 20px;
    padding-top: 10px;
    height: 200px;
    /* max-width: 250px; */
    background-color: #fff;
    border-radius: 10px;
    transition: 0.2s;
    position: relative;
    cursor: pointer;
  }
  .box3 {
    text-align: left;
    box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
    padding: 20px;
    padding-top: 10px;
    height: 200px;
    max-width: 250px;
    background-color: #fff;
    border-radius: 10px;
    transition: 0.2s;
    position: relative;
  }
  .box1:hover {
    transform: scale(1.05);
  }
  .goto {
    font-size: 30px;
    cursor: pointer;
    transition: 0.3s;
  }
  .goto:hover {
    color: rgb(64, 158, 255);
  }
  .icon {
    transform: translateY(8px);
    font-size: 30px;
    margin-right: 10px;
  }
  .box2 {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    border-radius: 10px;
    height: 200px;
    background-color: rgb(0, 0, 0, 0.3);
    z-index: 10000;
  }
</style>